import { tokenStore } from "../utils/tokenStore";

export function isAuthenticated(requiredRole = "ClinicImageEditor") {
  const { token } = tokenStore.get();
  if (!token) return false;

  try {
    const [, payloadB64] = token.split(".");
    const payload = JSON.parse(atob(payloadB64));
    const now = Math.floor(Date.now() / 1000);
    if (payload.exp && payload.exp <= now) return false;

    return true;
  } catch {
    return false;
  }
}
